import {
    newBuildingTypeMapper
} from '@search/offer-search-routes/src/mappers/newBuilding/mappers';
import { s } from '@search/router/src/schema';
import { Tokens } from '@search/router/src/RouterInterfaces';
import { numToStr, strToNum } from '@search/router/src/schema/strToNum';

import { NewBuildingRoute } from './NewBuildingRoute';

const NewBuildingConstructionCommonParams = {
    id: s.nullOpt(s.num)
};

const NewBuildingConstructionCommonSeoParams = {
    origin: s.nullOpt(s.str),
    id: s.nullOpt(s.str)
};

const newBuildingConstructionCommonDefaults = {};

export const NewBuildingConstructionType = s.rec({
    region: s.str,
    subRegion: s.nullOpt(s.str),
    type: s.opt(newBuildingTypeMapper.Type),
    name: s.str,

    ...NewBuildingConstructionCommonParams
});

export type INewBuildingConstructionType = ReturnType<typeof NewBuildingConstructionType>

export const NewBuildingConstructionSeoType = s.rec({
    region: s.nullOpt(s.str),
    subRegion: s.nullOpt(s.str),
    type: s.opt(newBuildingTypeMapper.SeoType),
    name: s.str,

    ...NewBuildingConstructionCommonSeoParams
});

export type INewBuildingConstructionSeoType = ReturnType<typeof NewBuildingConstructionSeoType>

export const newBuildingConstructionDefaults = {
    region: 'rossiya',

    ...newBuildingConstructionCommonDefaults
} as const;

export class NewBuildingConstructionRoute extends NewBuildingRoute<
    INewBuildingConstructionSeoType,
    INewBuildingConstructionType,
    typeof newBuildingConstructionDefaults
> {
    displayName = 'NewBuildingConstructionRoute';

    protected metadata = NewBuildingConstructionSeoType.config;

    protected pattern(params: Tokens<INewBuildingConstructionSeoType>) {
        return `${this.patternHost()}(/${
            params.region
        })/novostroyki(/${
            params.subRegion
        })/${
            params.type
        }-${
            params.name
        }-${
            params.id
        }/hod-stroitelstva/`;
    }

    protected conditions() {
        return {
            ...super.conditions(),
            id: '\\d+',
            type: newBuildingTypeMapper.keys
        };
    }

    defaults() {
        return newBuildingConstructionDefaults;
    }

    regionSlugSimple(regionId: number) {
        return this.context.rootRegions?.getById(regionId)?.translit ??
            this.defaultRegion().translit;
    }

    protected fromQuery(seoParams: INewBuildingConstructionSeoType) {
        seoParams = NewBuildingConstructionSeoType(seoParams);

        return NewBuildingConstructionType({
            region: this.regionSlugSimple(this.regionId(seoParams.region)),
            subRegion: seoParams.subRegion,
            type: seoParams.type,
            name: seoParams.name,
            id: strToNum(seoParams.id)
        });
    }

    protected toQuery(params: INewBuildingConstructionType) {
        params = NewBuildingConstructionType(params);

        return NewBuildingConstructionSeoType({
            ...this.regionParams(this.regionId(params.region)),
            subRegion: params.subRegion,
            type: params.type as INewBuildingConstructionSeoType['type'],
            name: params.name,
            id: numToStr(params.id)
        });
    }
}
